import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';

import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  env = environment;
  lista: any;
  baseUrl = `${this.env.endpointURL}/checkuser`;
  error: any;
  helper = new JwtHelperService();
  datosusuario: any = {
    exp: '',
    data:
    {
      rut: '',
      dv: '',
      nombre: '',
      mail: '',
      CDAplicacion: '',
      FCTermino: '',
      SiglaPto: '',
      CDTPUsuario: ''
    },
    iat: ''
  };

  constructor(private http: HttpClient, private router: Router) {}

  attemptAuth(rut: number, password: string) {
    const credentials = { 'rut': rut, 'password': password };
     //console.log(credentials);
    return this.http.post(this.baseUrl, credentials).pipe(
      map(resp => {
        
        if (resp['recordset'][0].noexiste) {
          
          this.error = resp['recordset'][0];
          return false;
        } else {
          this.lista = resp['recordset'];
          localStorage.setItem('session', this.lista);
          this.datosusuario = this.helper.decodeToken(this.lista);


          return this.helper.decodeToken(this.lista);
        }

      }));
  }
  logintoken(token) {
    const decoded = this.helper.decodeToken(token);
    return decoded.usr;

  }
  refreshToken(token) {
    //const currentUser = JSON.parse(localStorage.getItem('session'));
    localStorage.setItem('session', token);

  }
  getTokenExpirationDate(token: string): Date {
    try { 
     let decoded = this.helper.decodeToken(token);

    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  } catch(e) { 
    this.logout()
  }
   
  }
  nologin() {

  }
  getToken(): string {
    return localStorage.getItem('session');
  }
  getDataToken() {

    this.datosusuario = this.helper.decodeToken(this.getToken());

  }
  getroleToken() {
    this.datosusuario = this.helper.decodeToken(this.getToken());
    return this.datosusuario.data.CDTPPermiso;

  }
  isTokenExpired(token?: string): boolean {

    if (!token) {
      token = this.getToken();
    }
    if (!token) {
      return true;
    }

    const date = this.getTokenExpirationDate(token);
    if (date === undefined) {
      return false;
    }

    return !(date.valueOf() > new Date().valueOf());
  }
  autenticado() {
    return this.isTokenExpired();

  }
  logout() {
    localStorage.clear();
    this.autenticado();
    this.datosusuario = {
      exp: undefined,
      data:
      {
        rut: undefined,
        dv: undefined,
        nombre: undefined,
        mail: undefined,
        CDAplicacion: undefined,
        FCTermino: undefined,
        SiglaPto: undefined,
        CDTPUsuario: undefined
      },
      iat: undefined
    };
    this.router.navigate(['login']);

    
  }
}
